'use strict';

const React = require('react');

const PropTypes = require('prop-types');

function ItemTagIndicator({ styles }) {
    return (
        <div className={styles.wrapper}>
            <div className={`${styles.radius} ${styles.center}`} />
            <div className={`${styles.radius} ${styles.pulse}`} />
            <div className={`${styles.radius} ${styles.echo}`} />
        </div>
    );
}

ItemTagIndicator.propTypes = {
    styles: PropTypes.shape({
        wrapper: PropTypes.string,
        radius: PropTypes.string,
        center: PropTypes.string,
        pulse: PropTypes.string,
        echo: PropTypes.string,
    }).isRequired,
};

ItemTagIndicator.defaultProps = {
    styles: require('./ItemTagIndicator.scss'),
};

module.exports = ItemTagIndicator;



// WEBPACK FOOTER //
// ./assets/js/gallery/components/ItemTagIndicator.jsx